import { render, staticRenderFns } from "./RankingSearch.vue?vue&type=template&id=06d9fb1a&scoped=true&"
import script from "./RankingSearch.vue?vue&type=script&lang=js&"
export * from "./RankingSearch.vue?vue&type=script&lang=js&"
import style0 from "./RankingSearch.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RankingSearch.vue?vue&type=style&index=1&id=06d9fb1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d9fb1a",
  null
  
)

component.options.__file = "packages/cb-components-ranking/src/components/rank/RankingSearch.vue"
export default component.exports